import React, { useEffect } from "react";
import SearchHeader from "../../Common/SearchHeader";
import Filters from "../../Common/Filters";
import FindYourTribe from "../../Common/FindYourTribe";
import "./style.scss";
import EventsListing from "../../Common/EventsListing";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllEventCategories,
  getAllFilterEvents,
} from "../../../Redux/slices/eventSlice";
const AllEvents = () => {
  const { filteredEvents, filter, filterList, categories } = useSelector(
    (state) => state.event
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (categories.length === 0) {
      dispatch(getAllEventCategories());
    }
  }, []);

  useEffect(() => {
    dispatch(getAllFilterEvents({ filterData: { filter } }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, filterList]);

  return (
    <>
      <SearchHeader styleClass="header" showSearchBar={true} />
      <div className="allEvents">
        <Filters />
        <div className="events">
          <h1 className="all-events-heading">All Events</h1>
          <div className="fliter-list">
            {Object.values(filterList)?.map(
              (item) =>
                item && (
                  <p
                    key={`All-Events-Filter-${item}`}
                    className="filter border-radius-8"
                  >
                    {item}
                  </p>
                )
            )}
          </div>
          <div className="eventList">
            <EventsListing
              eventList={{ events: filteredEvents }}
              carousel={false}
            />
          </div>
        </div>
      </div>
      <FindYourTribe />
    </>
  );
};

export default AllEvents;
